import React, { useState, useEffect } from "react";
import { Input, Select, Radio } from "antd";
import arrowup from "../assets/arrowup.png";
import { useAppContext } from "../AppContext";
import axios from "axios";

const { Option } = Select;

const GetStarted = () => {

  const { selectedState, setSelectedState, setZipcodes, 
    zipcodes, selectedStateName, setSelectedStateName, 
    selectedMetro, setSelectedMetro } = useAppContext();

  const [stateOptions, setStateOptions] = useState([]);
  const [metroOptions, setMetroOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('state'); // Default to 'state'

  console.log(selectedState,'statename');
  
  // Fetch state options
  useEffect(() => {
    const fetchStateOptions = async () => {
      try {
        const response = await axios.post(
          "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getstatelist",
          {
            data: {
              statename: "",
              stateabbreviation: "",
            },
          }
        );
        const apiData = response.data.states || [];
        setStateOptions(apiData);
      } catch (error) {
        console.error("Failed to fetch state options:", error);
      }
    };
    fetchStateOptions();
  }, []);

  // Initial fetch: Get metro list with state='' and type='%'
  useEffect(() => {
    const fetchInitialMetroOptions = async () => {
      try {
        const response = await axios.post(
          "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getmetrolist",
          {
            state: "",
            type: "%",
          }
        );
        const apiData = response.data.metros || [];
        setMetroOptions(apiData);
      } catch (error) {
        console.error("Failed to fetch initial metro options:", error);
        setMetroOptions([]);
      }
    };
    fetchInitialMetroOptions();
  }, []);

  // Fetch metro options when metro option is selected or when state is selected
  useEffect(() => {
    const fetchMetroOptions = async () => {
      // If metro option is selected, fetch all metros with state="" and type="%"
      if (selectedOption === 'metro') {
        try {
          const response = await axios.post(
            "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getmetrolist",
            {
              state: "",
              type: "%",
            }
          );
          const apiData = response.data.metros || [];
          setMetroOptions(apiData);
        } catch (error) {
          console.error("Failed to fetch metro options:", error);
          setMetroOptions([]);
        }
      } 
      // If state is selected (and metro option is not selected), fetch metros for that state
      else if (selectedState?.stateabbreviation) {
        try {
          const response = await axios.post(
            "https://api.usfarmdata.org/capstone/capstone_geo_filter?operation=getmetrolist",
            {
              state: selectedState.stateabbreviation,
              type: "",
            }
          );
          const apiData = response.data.metros || [];
          setMetroOptions(apiData);
        } catch (error) {
          console.error("Failed to fetch metro options:", error);
          setMetroOptions([]);
        }
      }
    };
    fetchMetroOptions();
  }, [selectedState, selectedOption]);

  // Clear state if zipcodes or metro has value
  useEffect(() => {
    if ((zipcodes && zipcodes.trim() !== '') || selectedMetro) {
      // If zipcodes or metro has value, clear state
      setSelectedState(null);
      setSelectedStateName('');
    }
  }, [zipcodes, selectedMetro]);
  

  return (
    <section className="py-16 bg-[#E3E3E3]">
      <div className="block lg:flex max-w-6xl mx-auto px-5 lg:px-0">
        <div className="flex flex-col lg:flex-row justify-center gap-32">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left">
            <div className="mb-0 md:mb-12 max-w-lg">
              <p className="text-[#F09900] font-bold text-3xl leading-9">
                {" "}
                Get Started:{" "}
                <span className="text-[#4D6877]">
                  Pick your zip <br /> code, metro or state and we'll <br /> do
                  the rest!
                </span>
              </p>
              <div className="mt-4">
                <div className="list-disc ml-4 text-lg text-[#4D6877]">
                  <p>
                    Download and segment inside the 500 commercial cleaning
                    leads based on your marketing goals.
                  </p>

                  <p>
                    Launch your outreach through email, ads, calls, or <br />
                    direct mail.
                  </p>

                  <p>
                    Track your results and fine-tune for even better <br />
                    outcomes.
                  </p>
                </div>
              </div>
              <div className="mt-3">
                <p className="text-[#4D6877] text-lg leading-normal gap-y-2">
                  You don’t need an agency. You don’t need a big marketing team.
                  Just the right list and a smart plan. It’s that simple: You
                  get the list. You do the outreach.
                  <br /> And you keep 100% of the profits.
                </p>
              </div>

              <div className="font-semibold text-[#F09900] text-lg my-6">
                <p>Only $200 for 500 leads.</p>
                <p>Instant Download!</p>
              </div>
              <div className="flex items-center gap-2 text-lg text-gray-600 mt-2 font-medium">
                <img src={arrowup} width={25} />
                <span className="text-[#4D6877] font-semibold ml-2 italic">
                  Bonus Postcard, Brochure, and <br /> Voice Mail Script
                </span>
              </div>
              <div className="flex items-center gap-2 text-lg text-gray-600 font-medium lg: mt-4">
                <img src={arrowup} width={25} />
                <span className="text-[#4D6877] font-semibold ml-2 italic">
                  The Commercial Cleaning Marketing
                  <br /> Made Easy Marketing Kit
                </span>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="flex-shrink-0 md:min-w-lg lg:min-w-lg w-full lg:w-80">
            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-3 border-[#4D6877]">
              <div className="flex">
                <button className="flex-1 bg-[#F09900] text-white py-5 px-4 font-semibold">
                  <span className="text-white text-2xl">Geography</span>
                </button>
              </div>

              <div className="p-6 mb-4">
                <p className="text-2xl font-bold text-[#4D6877] mb-6 text-center font-semibold">
                  Get Your List Now
                </p>
                
                <div className="mb-4">
                  <p className="text-lg font-semibold text-[#4D6877] mb-3">
                    Select Your Option:
                  </p>
                </div>

                <div className="mt-3">
                  <Radio.Group
                    value={selectedOption}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedOption(value);
                      // Clear other selections when switching options
                      if (value === 'zipcodes') {
                        setSelectedState(null);
                        setSelectedStateName('');
                        setSelectedMetro(null);
                      } else if (value === 'metro') {
                        setZipcodes('');
                        setSelectedState(null);
                        setSelectedStateName('');
                      } else if (value === 'state') {
                        setZipcodes('');
                        setSelectedMetro(null);
                      }
                    }}
                    className="w-full"
                  >
                    <div className="space-y-4">
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-[#F09900] transition-colors">
                        <Radio value="zipcodes" className="w-full">
                          <span className="text-md font-medium text-[#4D6877]">
                            By Zipcodes
                          </span>
                        </Radio>
                        {selectedOption === 'zipcodes' && (
                          <div className="ml-6 mt-3 transition-all duration-300">
                            <p className="text-sm text-gray-600 mb-2">
                              I would like 500 new cleaning business records for zipcodes:
                            </p>
                            <Input 
                              size="medium" 
                              style={{ width: '100%', maxWidth: 250 }} 
                              value={zipcodes} 
                              onChange={(e) => setZipcodes(e.target.value)}
                              placeholder="Enter zipcodes"
                            />
                          </div>
                        )}
                      </div>
                      
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-[#F09900] transition-colors">
                        <Radio value="metro" className="w-full">
                          <span className="text-md font-medium text-[#4D6877]">
                            By Metro
                          </span>
                        </Radio>
                        {selectedOption === 'metro' && (
                          <div className="ml-6 mt-3 transition-all duration-300">
                            <p className="text-sm text-gray-600 mb-2">
                              I would like 500 commercial new business records for the following metro:
                            </p>
                            <Select
                              size="medium"
                              style={{ width: '100%', maxWidth: 250 }}
                              value={selectedMetro?.code || undefined}
                              onChange={(value) => {
                                const metro = metroOptions.find(m => m.code === value);
                                if (metro) {
                                  setSelectedMetro(metro);
                                }
                              }}
                              placeholder="Select metro"
                              showSearch
                              allowClear
                              onClear={() => setSelectedMetro(null)}
                              filterOption={(input, option) =>
                                (option?.children?.toLowerCase() ?? '').includes(input.toLowerCase())
                              }
                            >
                              {metroOptions.map((option) => (
                                <Option key={option.code} value={option.code}>
                                  {option.metro}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        )}
                      </div>
                      
                      <div className="border border-gray-200 rounded-lg p-3 hover:border-[#F09900] transition-colors">
                        <Radio value="state" className="w-full">
                          <span className="text-md font-medium text-[#4D6877]">
                            By State
                          </span>
                        </Radio>
                        {selectedOption === 'state' && (
                          <div className="ml-6 mt-3 transition-all duration-300">
                            <p className="text-sm text-gray-600 mb-2">
                              I would like 500 commercial new business records for the following state:
                            </p>
                            <Select
                              size="medium"
                              style={{ width: '100%', maxWidth: 250 }}
                              value={selectedState?.stateabbreviation || undefined}
                              onChange={(value) => {
                                const state = stateOptions.find(s => s.stateabbreviation === value);
                                if (state) {
                                  setSelectedState(state);
                                  setSelectedStateName(state.statename);
                                }
                              }}
                              placeholder="Select state"
                              showSearch
                              allowClear
                              onClear={() => {
                                setSelectedState(null);
                                setSelectedStateName('');
                              }}
                              filterOption={(input, option) =>
                                (option?.children?.toLowerCase() ?? '').includes(input.toLowerCase())
                              }
                            >
                              {stateOptions.map((option) => (
                                <Option key={option.stateabbreviation} value={option.stateabbreviation}>
                                  {option.statename}
                                </Option>
                              ))}
                            </Select>
                          </div>
                        )}
                      </div>
                    </div>
                  </Radio.Group>
                </div>
                {/* <div className="space-y-4">
                  <label className="block text-sm text-[#4D6877] mb-2">
                    Billing Details
                  </label>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    <Input
                      placeholder="First Name*"
                      className="border-blue-300"
                    />
                    <Input
                      placeholder="Last Name*"
                      className="border-blue-300"
                    />
                  </div>

                  <div className="mt-3">
                    <Input placeholder="Address*" className="border-blue-300" />
                  </div>

                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <Input placeholder="Apt #" className="border-blue-300" />
                    <Input
                      placeholder="Phone Number"
                      className="border-blue-300"
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-3 mt-3">
                    <Input placeholder="City*" className="border-blue-300" />
                    <Input placeholder="State*" className="border-blue-300" />
                    <Input placeholder="Zip*" className="border-blue-300" />
                  </div>

                  <div className="mt-6">
                    <a
                      href="https://stripe-frontend.netlify.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button
                        className="w-full bg-[#F09900] hover:bg-yellow-600 text-black font-bold py-4 transition-colors border-3 border-[#4D6877] cursor-pointer"
                        style={{ color: "white", fontSize: "28px" }}
                      >
                        Buy Now
                      </button>
                    </a>
                  </div>
                </div> */}
                <div className="mt-8">
                     <button
                        className="w-full bg-[#F09900] hover:bg-yellow-600 text-black font-bold py-4 transition-colors border-3 border-[#4D6877] cursor-pointer"
                        style={{ color: "white", fontSize: "28px" }}
                      >
                        Buy Now
                      </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;